import 'angular:locale/data:nl';
import 'angular:locale/data:fr';
import 'angular:locale/data:en';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
